import React, { useState, useEffect } from 'react';
import '../styles/AIAssistant.style';

const Loader = () => {
  const [dot, setDot] = useState(0);

  useEffect(() => {
    const interval = setInterval(() => {
      setDot((prevDot) => (prevDot + 1) % 3);
    }, 1000);
    return () => clearInterval(interval);
  }, []);

  const active = 'active-dot';
  const disable = 'disable-dot';
  return (
    <div className="loader">
      <span className= {dot === 0 ? active: disable}>.</span>
      <span className= {dot === 1 ? active: disable}>.</span>
      <span className= {dot === 2 ? active: disable}>.</span>
    </div>
  );
};

export default Loader;
